import { makeAutoObservable } from "mobx";
import lodash from "lodash";


export class UserStore {
  isLoggedIn = false;
  user = {};
  username = ''
  id = ''
  email = ''
  isSubscribed = true;
  panelTypes = []
  outputPageOutput = {}

  constructor() {
    makeAutoObservable(this);
  }

  setIsLoggedIn = (boolean) => {
    this.isLoggedIn = boolean;
  };

  setUser = (user) => {
    this.user = user;
    this.username = user.username;
    this.id = user.id;
    this.email = user.email;
  };

  setIsSubscribed = (boolean) => {
    this.isSubscribed = boolean;
  }

  setPanelTypes(panel) {
    this.panelTypes = panel;
  }

  addPanelTypes(panelList) {
    let oldList = this.panelTypes;
    panelList.forEach((panel) => oldList.push(panel));
    this.setPanelTypes(oldList);
  }

  addSinglePanelType(panel) {
    let oldList = lodash.clone(this.panelTypes);
    oldList.push(panel);
    this.setPanelTypes(oldList);
  }

  updatePanelType(panel) {
    let filteredList = this.panelTypes.filter(
      (thisPanel) => thisPanel.id !== panel.id
    );
    filteredList.push(panel);
    this.panelTypes = filteredList;
  }

  removePanelType(panel) {
    let filteredList = this.panelTypes.filter(
      (thisPanel) => thisPanel.id !== panel.id
    );
    this.panelTypes = filteredList;
  }

  setOutputPageOutput(obj) {
    this.outputPageOutput = obj;
  }

}